<template>
 <div v-loading="loading">
   <folder-list :documents="documents" :user="visit.user.id"></folder-list>
 </div>

</template>

<script>
import  FolderList from "@/components/documents/FolderList"
import {mapGetters, mapActions} from "vuex";

export default {
  name: "visit.documents",

  data: () => ({
    loading: true,
    documents: []
  }),
  computed: {
    ...mapGetters("visit", {
      visit: "data",
    }),
  },
  mounted() {

    this.setStageVisit(3)


    if(!this.visit) return

    this.loading = true


    this.$api.documents.getList(this.visit.user.id).then((response) => {
      this.documents  = response.data
    }).catch((response) => {

      this.$notify.error({
        title: "Ошибка загрузки документов",
        message: response.response.data.message,
      })

    }).finally(() => {
      this.loading = false
    })

  },
  components: { FolderList },
  methods: {
    ...mapActions({
      setStageVisit: "visit/SET_STAGE",
    }),
  }
}
</script>

<style scoped lang="scss">


</style>
